<template>
    <b-modal id="editModal" ref="modal" :title="title" @hide="onHide" @cancel="onCancel" :centered="true" :visible="open" :ok-title="okTitle" :hide-footer="hideFooterVal"
     :cancel-title="$t('general.cancel')" :size="size" @ok="saveModal" :ok-disabled="disabled" :static="true">
         <b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner>
        <component v-else ref="modalForm" :sendRequest="sendRequest" v-bind:is="renderModalForm"  :save="saveAct"
            :data="modalProps" :saveState="saveState" :modalName="modalName" :modalEvent="modalEvent" :formName="form"
            :onComplete="onComplete" :forms="forms[form]" :input="input" :changeVal="changeDisabled">
        </component>
    </b-modal>
</template>

<script>
   
    import i18n from '@/plugins/i18n';
    import Auth from './Auth'
    import SetStateUser from './SetStateUser'
    import Delete from './Delete'
    import Form from '@/components/Form'
    import Forms from '../forms'
    import {prepareRequestData, sendRequestList, sendRequest} from '@/assets/js/custom.js'

    export default {
        name: 'UserModal',
        data: function(){
            return{
                title: '',
                okTitle: i18n.t('general.save'),
                disabled: false,
                saveAct: false,
                input: [],
                size: 'lg',
                hideFooterVal: false,
                forms: Forms
            }
        },
        props:{
            open: Boolean,
            modalEvent: Function,
            form: String,
            modalName: String,
            modalProps: Object,
            onComplete: Function,
            
        },
        components:{
            Auth, SetStateUser, Delete
        },
        computed:{
            //Açılacak Modalı belirleme işlemleri
            renderModalForm: function(){
                this.hideFooterVal = false
                this.disabled = false
                this.input = []
                this.size = 'lg'
                this.title = i18n.t('general.'+this.modalName)
                this.okTitle = i18n.t('general.'+this.modalName)
                if(this.modalName === "delete") {
                    return "Delete"
                }else if(this.modalName === "LDAPData"){
                    this.title = this.modalProps && this.modalProps.description
                    this.hideFooterVal = true
                }else if(this.modalName === "SetState"){
                    this.title = this.modalProps && this.modalProps.name
                    this.okTitle= i18n.t('general.save')
                    return "SetState"
                }
                sendRequestList(this.forms[this.form], this)
                return Form
            },
        },
        methods:{
            sendRequest: async function(){ 
                await sendRequest(this)
                if(this.$store.getters.getUserStatus.status == "Success" || this.$store.getters.getLDAPStatus.status == "Success"){
                    await this.$store.dispatch((this.form+'_get').toLowerCase(), {parent_id: parseInt(this.$route.params.id)})
                    this.modalEvent(false)
                }
                this.saveState(false)
            },
            onHide: function(){
                if(!this.saveAct)
                    this.modalEvent(false)
            },
            onCancel: function(){
                this.saveState(false)
                if(!this.saveAct)
                    this.modalEvent(false)

            },
            saveState: function(val){
                this.saveAct = val
            },
            // Modal tamamlandığı zaman olacak event
            saveModal: async function(bvModalEvt){
                bvModalEvt.preventDefault()
                // Modalın içerisindeki watchı tetikler
                this.saveState(true)
            },
            changeData(val, name){
                this.modalProps[name] = val
            },
            changeDisabled(val){
                if(val == this.modalProps.name)
                    this.disabled = false
            }
        },
        watch:{
            saveAct(){
                return false
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/General/Users/modals/index.vue